export const MIN_DAILY_DAMAGE_CAP = 10;
export const MAX_DAILY_DAMAGE_CAP = 80;
export const DEFAULT_DAILY_DAMAGE_CAP = 20;

export const DAILY_DAMAGE_CAP_VALUES: number[] = Array.from(
    { length: MAX_DAILY_DAMAGE_CAP - MIN_DAILY_DAMAGE_CAP + 1 },
    (_, i) => MIN_DAILY_DAMAGE_CAP + i,
);

export type DailyDamageCapValidation = { ok: true; cap: number } | { ok: false; message: string };

export function validateDailyDamageCap(n: number): DailyDamageCapValidation {
    const cap = Math.round(n);
    if (!Number.isFinite(cap)) {
        return { ok: false, message: 'Enter a valid damage limit' };
    }
    if (cap < MIN_DAILY_DAMAGE_CAP || cap > MAX_DAILY_DAMAGE_CAP) {
        return {
            ok: false,
            message: `Damage limit must be between ${MIN_DAILY_DAMAGE_CAP} and ${MAX_DAILY_DAMAGE_CAP} HP`,
        };
    }
    return { ok: true, cap };
}

export function parseDailyDamageCapRaw(raw: string): DailyDamageCapValidation {
    const t = raw.trim();
    if (t === '') {
        return { ok: true, cap: DEFAULT_DAILY_DAMAGE_CAP };
    }
    return validateDailyDamageCap(Number.parseInt(t, 10));
}

export function normalizeDailyDamageCap(n: number): number {
    const checked = validateDailyDamageCap(n);
    if (!checked.ok) throw new Error('INVALID_DAILY_DAMAGE_CAP');
    return checked.cap;
}
